module.exports = __webpack_public_path__ + "static/img/2.84deaa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/2.jpg
// module id = TgtD
// module chunks = 16